import React, { useState, useEffect } from 'react';
import { AuditScreen } from './AuditScreen';
import {
  OpenLinksQuery,
  OutsideOwnershipAccessQuery,
  OutsideOrganizationAccessQuery,
  PersonalAccountAccessQuery,
} from 'services/apollo/auditQueries/auditQueries';
import { getApolloClient, AsyncStorage, Logger } from 'services';
import styles from 'screens/AuditScreens/screens/AuditScreen/AuditScreen.module.scss';
import { AuthLoader } from 'screens/LoginScreen/components/AuthLoader';

export const AuditQueue = () => {
  const [finished, setFinished] = useState(false);
  const [failed, setFailed] = useState(false);

  async function getAllDataForAuditScreen() {
    const timestampFromStorage = (await AsyncStorage.get('auditTimestamp')) as string;

    function determineFetchPolicy() {
      var currentTime = new Date() as any;
      var lastReportGeneratedTime = new Date(timestampFromStorage) as any;
      var timeSinceLastReportGenerated = currentTime - lastReportGeneratedTime;
      var fiveMinutes = 5 * 60 * 1000;
      if (!timestampFromStorage) {
        Logger.log('Get audit data for the first time');
        return 'network-only';
      } else if (timeSinceLastReportGenerated > fiveMinutes) {
        Logger.log('Get fresh audit data, more than 5 minutes have elapsed since last fetched');
        return 'network-only';
      } else {
        Logger.log('Use cached audit data, less than 5 minutes have elapsed since last fetched');
        return 'cache-first';
      }
    }
    const promise1 = new Promise((resolve, reject) => {
      const getData = getApolloClient().then((client) =>
        client.query({
          query: OpenLinksQuery,
          variables: { first: 20, cursor: '' },
          fetchPolicy: determineFetchPolicy(),
        })
      );
      getData
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
    const promise2 = new Promise((resolve, reject) => {
      const getData = getApolloClient().then((client) =>
        client.query({
          query: OutsideOwnershipAccessQuery,
          variables: { first: 20, cursor: '' },
          fetchPolicy: determineFetchPolicy(),
        })
      );
      getData
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
    const promise3 = new Promise((resolve, reject) => {
      const getData = getApolloClient().then((client) =>
        client.query({
          query: OutsideOrganizationAccessQuery,
          variables: { first: 20, cursor: '' },
          fetchPolicy: determineFetchPolicy(),
        })
      );
      getData
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
    const promise4 = new Promise((resolve, reject) => {
      const getData = getApolloClient().then((client) =>
        client.query({
          query: PersonalAccountAccessQuery,
          variables: { first: 20, cursor: '' },
          fetchPolicy: determineFetchPolicy(),
        })
      );
      getData
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    });

    return Promise.all([promise1, promise2, promise3, promise4]);
  }

  useEffect(() => {
    getAllDataForAuditScreen()
      .then(() => {
        AsyncStorage.set('auditTimestamp', new Date().toString());
        setFinished(true);
      })
      .catch(function (err) {
        setFailed(true);
      });
  }, []);

  if (finished === true) {
    return <AuditScreen />;
  }

  if (failed === true) {
    return <Error />;
  }

  return <AuthLoader type="DSA" />;
};

const Error = () => {
  return (
    <div className={styles.container}>
      <div className={styles.errorContainer}>
        <div className={styles.errorHeader}>
          <h3 className={styles.errorTitle}>Error</h3>
        </div>
        <div className={styles.errorContent}>
          <div>It seems there was a problem generating your audit report</div>
        </div>
      </div>
    </div>
  );
};
